module.exports = __webpack_public_path__ + "img/mtl.9cb2df25.svg";